/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(applicationId) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetCheckCasherRenewalApplication: {
        $xmlns: 'http://dobs.pa.gov/nd/application/bpm/1.0',
        ApplicationID: applicationId
      }
    },
    blueprintArrays: [
      'GetCheckCasherRenewalApplicationResponse.BranchLicenses.ND_AppLicenseCheckCasherRenewBranch',
      'GetCheckCasherRenewalApplicationResponse.ApplicationDocuments.ND_ApplicationDocument'
    ],
    blueprint: {
      id: '$..ND_AppLicenseCheckCasherRenew.ID',
      applicationId: '$..ND_AppLicenseCheckCasherRenew.ApplicationID',
      isFoodEstablishment: '$..IsFoodEstablishment',
      isPublicEating: '$..IsPublicEating',
      hasLegalProceedings: '$..HasLegalProceedings',
      hasLegalProceedingsExplaination: '$..HasLegalProceedingsExplaination',
      hasUpdatedLicenseContacts: '$..HasUpdatedLicenseContacts',
      hasLegalProceedingsDocument: {
        fileId: '$..HasLegalProceedingsDocumentID',
        fileName: '$..HasLegalProceedingsDocumentName'
      },
      grossIncome: '$..GrossIncome',
      checkCasherIncome: '$..CheckCasherIncome',
      foodEstablishmentDocument: {
        fileId: '$..FoodEstablishmentDocumentID',
        fileName: '$..FoodEstablishmentDocumentName'
      },
      publicEatingDocument: {
        fileId: '$..PublicEatingDocumentID',
        fileName: '$..PublicEatingDocumentName'
      },
      zoningLawsDocument: {
        fileId: '$..LocalZoningLawDocumentID',
        fileName: '$..LocalZoningLawDocumentName'
      },
      municipalCountyOrdinanceDocument: {
        fileId: '$..MunicipalCountyOrdinanceDocumentID',
        fileName: '$..MunicipalCountyOrdinanceDocumentName'
      },
      retailFoodRegistrationDocument: {
        fileId: '$..RetailFoodRegistrationDocumentID',
        fileName: '$..RetailFoodRegistrationDocumentName'
      },
      certificationName: '$..CertificationName',
      isCertified: '$..IsCertified',
      branchLicenses: [
        '$..ND_AppLicenseCheckCasherRenewBranch',
        {
          id: '$.ID',
          applicationId: '$.ApplicationID',
          branchLicenseId: '$.BranchLicenseID',
          isRenewing: '$.IsRenewing',
          isRenewed: '$.IsRenewed', //checks if ND_LicenseRenewal record exists for the Branch License
          paidDate: '$.PaidDate'
        }
      ],
      applicationDocuments: [
        '$..ND_ApplicationDocument',
        {
          fileId: '$.DocumentID',
          fileName: '$..Name'
        }
      ],
      isResubmission: '$..IsResubmission'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      response.isCertified = response.isCertified === '1';

      _.each(response.branchLicenses, function(branchLicense) {
        branchLicense.isRenewing = branchLicense.isRenewing === '1';
        branchLicense.isRenewed = branchLicense.isRenewed === '1';
      });

      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });
  return defer.promise();
};
